import {
  MARKETING_URL_DE,
  MARKETING_URL_EN,
} from '@xing-com/crate-entity-pages-entity-pages-shared-urls';

export const TRACKING_PARAMETER_BASE =
  '?sc_o= entity_page_companies_start_upsell_cover_image_module&sc_o_PropActionOrigin=entity_page_companies_upgrade_main_';

type GetMarketingPageUrl = {
  locale: string;
  moduleName?: string;
  focusType?: string;
  component?: string;
  isProductPage?: boolean;
};

export const getTrackingParameter = (hasImage: boolean): string => {
  const trackingParameterSuffix = hasImage ? 'draft' : 'none';
  return TRACKING_PARAMETER_BASE + trackingParameterSuffix;
};

export const getMarketingPageUrl = ({
  locale,
  moduleName,
  focusType,
  component = '',
  isProductPage,
}: GetMarketingPageUrl) => {
  let url;
  if (isProductPage) {
    const language = locale === 'en' ? 'en' : 'de';
    url = `https://recruiting.xing.com/${language}/products/xing-360`;
  } else {
    url = locale === 'en' ? MARKETING_URL_EN : MARKETING_URL_DE;
  }
  if (focusType === 'COMPANY' && moduleName) {
    url += `?sc_o=entity_page_companies_start_upsell_${moduleName}`;

    if (component.length) {
      url += `_${component}`;
    }
  }
  return url;
};
